import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  getDocument,
  getDocumentTypes,
  getFileTypes,
  getDocumentById,
  uploadDocument,
  getLgasByState,
  getStates,
  uploadVehicleDocs,
  getVehicleDocuments,
  getVehicleDocsType,
  getCorporateDocuments,
  getDownloadTemplate,
  submitVehicleDocuments,
  getDocumentStatus,
} from "../api/document";
import { AxiosError, AxiosProgressEvent } from "axios";
// import { verifyIndividual } from "store/api/account";
import { CorporateDocument, ProfileImage } from "store/api/models";
import { getBanks } from "store/api/corporate-director";
import { useAppDispatch } from "customHooks/useAppDispatch";

// Example async thunk for fetching a document
export const getDocumentAsync = createAsyncThunk(
  "document/getDocument",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDocument();
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

// Example async thunk for creating a document
export const uploadDocumentAsync = createAsyncThunk(
  "document/uploadDocument",
  async (documentData: ProfileImage, { rejectWithValue }) => {
    try {
      const response = await uploadDocument(documentData);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

// Example async thunk for updating a document
export const byIdGetDocumentAsync = createAsyncThunk(
  "document/byIdGetDocument",
  async (documentData: string, { rejectWithValue }) => {
    try {
      const response = await getDocumentById(documentData);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

// Example async thunk for deleting a document
export const typesOfDocumentAsync = createAsyncThunk(
  "document/typesOfDocument",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDocumentTypes();
      return response?.data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

// Example async thunk for deleting a document
export const typesOfFileAsync = createAsyncThunk(
  "document/typesOfFile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getFileTypes();
      return response?.data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const searchStates = createAsyncThunk(
  "state/List of states",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getStates();
      return res?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const searchLga = createAsyncThunk(
  "state/lgas by State",
  async (stateName: string, { rejectWithValue }) => {
    try {
      const res = await getLgasByState(stateName);
      return res?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

// const downloadFile = (data: BlobPart, filename: string, mime: any) => {
//   const blob = new Blob([data], { type: mime });
//   const url = window.URL.createObjectURL(blob);
//   const a = document.createElement('a');
//   a.style.display = 'none';
//   a.href = url;
//   a.download = filename;
//   document.body.appendChild(a);
//   a.click();
//   window.URL.revokeObjectURL(url);
// };

// export const downloadTemplate = createAsyncThunk(
//   "document/download-template",
//   async (documentype: string, { rejectWithValue }) => {
//     try {
//       const res = await getDownloadTemplate(documentype);
//       console.log("baby", res)

//       if (res && res.data) {
//         const filename = `${documentype}-template.pdf`;
//         const mime = res.headers['content-type'] || 'application/octet-stream';

//         downloadFile(res.data, filename, mime);
//       }

//       return res

//         return res?.config?.url;
//     } catch (error) {
//       if (error instanceof AxiosError)
//         if (error?.response?.data || error?.message) {
//           return rejectWithValue(
//             error?.response?.data?.Message || error?.message
//           );
//         }
//     }
//   }
// );

export const getAllBanks = createAsyncThunk(
  "List of Banks",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBanks();
      return res?.data?.Data?.response_data as { name: string; code: string }[];
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getVehicleFinanceDocsTypes = createAsyncThunk(
  "document/vehicleDocsTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getVehicleDocsType();
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const submitAllVehicleFinanceDocsTypes = createAsyncThunk(
  "document/submitvehicleDocsTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await submitVehicleDocuments();
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getUserCorporateDocumentsAsync = createAsyncThunk(
  "List of Uploaded Corporate Documents",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCorporateDocuments();
      return res?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const uploadVehicleDocuments = createAsyncThunk(
  "vehicle/vehicleDocumentsUpload",
  async (payload: any, { rejectWithValue, dispatch }) => {
    let body = {
      Id: payload?.Id,
      FileData: payload.FileData,
      IdNumber: payload?.IdNumber,
      DocumentType: payload.DocumentType,
      Status: payload.Status,
      IssuedDate: payload.IssuedDate,
      ExpiryDate: payload.ExpiryDate,
    };
    const index = payload.Index;

    const config = {
      onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        const progress =
          Math.round(progressEvent.loaded * 100) / (progressEvent.total ?? 100);
        dispatch(updateProgress({ index, progress }));
      },
    };
    try {
      const response = await uploadVehicleDocs(body, config);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getVehicleDocs = createAsyncThunk(
  "document/vehicleDocs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getVehicleDocuments();
      return response?.data.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getAllDocumentStatus = createAsyncThunk(
  "document/getAllDocumentStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getDocumentStatus();
      return response?.data.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export type DocumentState = {
  document: any;
  documentTypes: any;
  vehicleDocumentTypes: any;
  documentStatus: any;
  vehicleDocsUpload: any;
  fileTypes: string[];
  documentById: string[];
  states: {
    Name: "string";
    CapitalName: "string";
  }[];
  lgas: {
    Name: "string";
  }[];
  banks: {
    name: string;
    code: string;
  }[];
  vehicleDocuments: any;
  corporateDocuments: CorporateDocument[];
  files: any;
  uploading: { [key: number]: boolean };
  progress: any;
  sizeError: any;
  isLoadingVehicleDocTypes: boolean;
};

const initialState: DocumentState = {
  document: [],
  documentTypes: [],
  fileTypes: [],
  documentById: [],
  states: [],
  lgas: [],
  banks: [],
  vehicleDocuments: [],
  vehicleDocumentTypes: [],
  vehicleDocsUpload: {},
  documentStatus: "",
  corporateDocuments: [],
  files: {},
  uploading: {},
  progress: [],
  sizeError: [],
  isLoadingVehicleDocTypes: false,
};

const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setFile: (state, action) => {
      const { index, file } = action.payload;
      state.files[index] = file;
      state.sizeError[index] = null;
    },
    deleteVehicleDocument: (state, action) => {
      const index = action?.payload?.data;
      state.files[index] = null;
      state.progress[index] = 0;
      state.sizeError[index] = null;
    },
    closeVehicleDocsModal: (state) => {},
    updateProgress: (state, action) => {
      const { index, progress } = action.payload;
      state.progress[index] = progress;
      state.sizeError[index] = null;
    },
    setError: (
      state,
      action: PayloadAction<{ index: number; error: string }>
    ) => {
      const { index, error } = action.payload;
      state.sizeError[index] = error;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserCorporateDocumentsAsync.fulfilled, (state, action) => {
        state.corporateDocuments = action.payload ?? [];
      })
      .addCase(getDocumentAsync.fulfilled, (state, action) => {
        state.document = action.payload;
      })
      .addCase(uploadDocumentAsync.fulfilled, (state, action) => {
        state.document = action.payload;
      })
      .addCase(byIdGetDocumentAsync.fulfilled, (state, action) => {
        state.documentById = action.payload;
      })
      .addCase(typesOfDocumentAsync.fulfilled, (state, action) => {
        state.documentTypes = action.payload;
      })
      .addCase(typesOfFileAsync.fulfilled, (state, action) => {
        state.fileTypes = action.payload;
      })
      .addCase(searchStates.fulfilled, (state, action) => {
        state.states = action.payload;
      })
      .addCase(getAllBanks.fulfilled, (state, action) => {
        state.banks = action.payload ?? [];
      })
      .addCase(searchLga.fulfilled, (state, action) => {
        state.lgas = action.payload;
      })

      .addCase(getVehicleDocs.pending, (state) => {
        state.isLoadingVehicleDocTypes = true;
      })
      .addCase(getVehicleDocs.fulfilled, (state, action) => {
        state.isLoadingVehicleDocTypes = false;
        state.vehicleDocuments = action.payload;
        state.files[action.payload.index] = null;
      })
      .addCase(getVehicleDocs.rejected, (state, action) => {
        state.isLoadingVehicleDocTypes = false;
      })

      .addCase(getVehicleFinanceDocsTypes.fulfilled, (state, action) => {
        state.vehicleDocumentTypes = action.payload;
      })

      .addCase(getAllDocumentStatus.fulfilled, (state, action) => {
        state.documentStatus = action.payload;
      })

      .addCase(submitAllVehicleFinanceDocsTypes.fulfilled, (state, action) => {
        state.vehicleDocsUpload = action.payload;
      })

      .addCase(uploadVehicleDocuments.pending, (state, action) => {
        const index = action.meta.arg.Index;
        state.uploading[index] = true;
        state.progress[index] = 0;
      })
      .addCase(uploadVehicleDocuments.fulfilled, (state, action) => {
        const index = action.meta.arg.Index;
        state.uploading[index] = false;
        state.progress[index] = 100;
      })
      .addCase(uploadVehicleDocuments.rejected, (state, action) => {
        const index = action.meta.arg.Index;
        state.uploading[index] = false;
        state.progress[index] = 0;
        state.sizeError[index] = action.payload as string;
      });
  },
});
export const {
  setFile,
  updateProgress,
  setError,
  deleteVehicleDocument,
  closeVehicleDocsModal,
} = documentSlice.actions;
export const documentReducer = documentSlice.reducer;
